import { Injectable } from '@angular/core';
import {HttpErrorResponse, HttpClient} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EnvService } from '../../core/services/env.service';
import { CallBackTransformService } from '../../core/services/call-back-transform.service';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ErrorLogService {

    constructor(
        private envService: EnvService,
        private http: HttpClient,
        private callBackTransformService: CallBackTransformService
    ) { }


    error: { errorMessage: string; isClient: boolean; token?: string } = {
        errorMessage: '',
        isClient: true,
        token : localStorage.getItem('token')
    };

    logError(err: any) {
        let isNoInternetErr = false;
        if (err instanceof HttpErrorResponse) {
            isNoInternetErr = (<HttpErrorResponse> err).status === 0 ? true : false;
            this.error['errorMessage'] = 'HTTP Error: ' + (<HttpErrorResponse> err).status + ': ' + err.message;
        } else if (err instanceof TypeError) {
            this.error['errorMessage'] = 'Type Error: ' + err.message;
        } else if (err instanceof Error) {
            this.error['errorMessage'] = 'General Error: ' + err.message;
        } else {
            this.error['errorMessage'] = 'General Error: ' + err;
        }
        if (!isNoInternetErr && this.envService.enableErrorLogging) {
            // tslint:disable-next-line: deprecation
            this.addLog(this.error).subscribe((res) => {});
        }
    }

    /**
     * addLog
     * @param Object none
     * @return Object Resultset
    */
    addLog(logInfo): Observable<any> {
        const url = this.envService.apiUrl + 'error-log';
        return this.http.post<any>(url, logInfo).pipe(
            map((output) => {
                return this.callBackTransformService.transformOutput(output);
            }),
            catchError((err) => {
                return throwError(this.callBackTransformService.transformOutput(err));
            })
        );
    }
}
